import { render, staticRenderFns } from "./NewCampaignLayout.vue?vue&type=template&id=2a285bd4&scoped=true&"
import script from "./NewCampaignLayout.vue?vue&type=script&lang=ts&"
export * from "./NewCampaignLayout.vue?vue&type=script&lang=ts&"
import style0 from "./NewCampaignLayout.vue?vue&type=style&index=0&id=2a285bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a285bd4",
  null
  
)

export default component.exports